import { useMediaQuery } from 'react-responsive'
import { Placeholder } from 'semantic-ui-react'

import styles from './style.module.css'

export default function EmptyApplicationCard() {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 820px)' })

  const PlaceholderExampleFluid = () => (
    <Placeholder fluid>
      <Placeholder.Header>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  )

  if (isTabletOrMobile) {
    return (
      <div className={`${styles.mobileCardContainer}`}>
        <div className={styles.wrapper}>
          <PlaceholderExampleFluid />
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.cardContainer}`}>
      <div className={styles.wrapper}>
        <PlaceholderExampleFluid />
      </div>
    </div>
  )
}
